<script>
import ShareNetwork from 'vue-social-sharing/src/share-network';

export default {
  beforeCreate: function () {
    this.$options.components.CpSharePost = require('./share-post.vue').default;
  },
  components: {
    ShareNetwork,
    CpCopyToClipboardTrigger: require('../copy-to-clipboard-trigger').default,
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    ShareIcon: require('../social-feed/icons/share-icon').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
  },
  props: {
    isModal: { type: Boolean, default: true },
    url: String,
    explore: Boolean,
    allowShareFeed: { type: Boolean, default: false },
    title: String,
    description: { type: String, default: '' },
    quote: String,
    hashtags: String,
    twitterUser: String,
    type: String,
    post: Object,
    shareCategory: String,
    shareButtonClass: { type: String, default: '' },
    resultsUrlSuffix: [String, Boolean],
    notModal: Boolean,
    openShare: { type: Boolean, default: false },
    handleShareModal: Function,
  },
  name: 'CpSocialShareDialog',
  methods: {
    handleDialogs() {
      this.showDialog = false;
      this.showDialogShare = true;
    },
    handleDialogShare() {
      if (this.openShare) {
        this.handleShareModal({});
      }
      this.showDialogShare = !this.showDialogShare;
    },
    handleShowDialog() {
      if (this.openShare && this.showDialog) {
        this.handleShareModal({});
      }
      this.showDialog = !this.showDialog;
    },
    bodyText() {
      if (this.description) {
        return this.description + '%0A' + '%0A';
      } else {
        return this.description;
      }
    },
    blueskyRedirection() {
      const pageUrl = this.encodeUrl('bluesky');
      return `https://bsky.app/intent/compose?text=${this.title}%20${encodeURIComponent(pageUrl)}`;
    },
    emailRedirection() {
      const urlEncoded = encodeURIComponent(this.encodeUrl('email'));
      return 'mailto:?subject=' + this.title + '&body=' + this.bodyText() + urlEncoded;
    },
    smsRedirection() {
      const urlEncoded = encodeURIComponent(this.encodeUrl('sms'));
      return 'sms:?&body=' + this.bodyText() + urlEncoded;
    },
    encodeUrl(network) {
      let url = new URL(this.url);
      let params = new URLSearchParams(url.search);
      params.set('ref_code', network + '-share');
      url.search = params.toString();
      return url.toString();
    },
  },
  data() {
    return {
      showDialog: false,
      showDialogShare: false,
      networks: [
        { network: 'twitter', name: 'X (Twitter)', image: '/assets/img/twitter-x-icon.svg' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook fa-2x facebook-color' },
        { network: 'linkedin', name: 'LinkedIn', icon: 'fab fa-linkedin fa-2x linkedin-color' },
        { network: 'reddit', name: 'Reddit', icon: 'fab fa-reddit-alien fa-2x reddit-color' },
        { network: 'flipboard', name: 'Flipboard', icon: 'fab fa-flipboard fa-2x flipboard-color' },
        { network: 'pinterest', name: 'Pinterest', icon: 'fab fa-pinterest fa-2x pinterest-color' },
        { network: 'quora', name: 'Quora', icon: 'fab fa-quora fa-2x quora-color' },
        { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp fa-2x whatsapp-color' },
      ],
    };
  },
  computed: {
    urlOpinion() {
      return encodeURIComponent(this.url);
    },
  },
  mounted() {
    if (this.openShare) {
      this.handleShowDialog();
    }
  },
};
</script>
<template>
  <div v-bind:class="{ campaign: shareCategory == 'Campaign' && !notModal, mobile: $root.isMobile }">
    <template v-if="isModal && !notModal">
      <cp-button
        v-if="shareCategory != 'Event' && !openShare"
        bold
        :class="'button--darkgray-outline ' + shareButtonClass"
        @click.prevent="handleShowDialog()"
        style="width: 100%"
      >
        <span style="display: flex; align-items: center">
          <cp-base-svg-icon :width="15" :height="15" viewBox="0 0 18 15" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
            <share-icon />
          </cp-base-svg-icon>
          <span class="body primary-blue-400-color" v-if="!$root.isMobile">Share</span>
        </span>
      </cp-button>
      <cp-button v-else-if="shareCategory == 'Event' && !openShare" bold @click.prevent="handleShowDialog()" style="width: 100%">
        <span style="display: flex; align-items: center">
          <cp-base-svg-icon :width="15" :height="15" viewBox="0 0 18 15" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
            <share-icon />
          </cp-base-svg-icon>
          <span class="body primary-blue-400-color" v-if="!$root.isMobile">Share</span>
        </span>
      </cp-button>
      <cp-dialog v-if="showDialog" @dismiss="handleShowDialog()">
        <cp-box>
          <cp-box-content>
            <section style="margin: 4em 2.5em; max-width: 55ch; text-align: center">
              <header class="heading-1">Share {{ shareCategory }}</header>
              <br />

              <div style="margin-bottom: 25px; align-items: center" v-if="shareCategory != 'CrowdpacTv' && allowShareFeed">
                <p class="heading-2">CrowdBlue Explore Feed</p>
                <cp-button bold primary @click="handleDialogs" class="btn-share-feed"> Share </cp-button>
              </div>

              <i @click.prevent="handleShowDialog" class="fal fa-times primary-color fa-2x close-icon"></i>
              <div class="share-network-list">
                <a :href="blueskyRedirection()" target="_blank" class="share-network-sms"
                  ><img src="/assets/img/bluesky-icon.svg" class="twitter-img" />
                  <p class="footnote neutral4-color" v-margin="0">Bluesky</p>
                </a>
                <share-network
                  v-for="network in networks"
                  :network="network.network"
                  :key="network.network"
                  :url="network.network !== 'whatsapp' ? encodeUrl(network.network) : ''"
                  :title="title"
                  :description="`${description}\n${encodeUrl(network.network)}`"
                  :quote="quote"
                  :hashtags="hashtags"
                  :twitterUser="twitterUser"
                >
                  <img v-if="network.image" :src="network.image" class="twitter-img" />
                  <i v-else :class="network.icon"></i>
                  <p class="footnote neutral4-color" v-margin="0">{{ network.name }}</p>
                </share-network>
                <a :href="smsRedirection()" class="share-network-sms"
                  ><i class="fal fa-comment-dots fa-2x black-color"></i>
                  <p class="footnote neutral4-color" v-margin="0">SMS</p>
                </a>
                <a :href="emailRedirection()" class="share-network-email"
                  ><i class="fal fa-envelope fa-2x black-color"></i>
                  <p class="footnote neutral4-color" v-margin="0">Email</p>
                </a>
                <a class="clipboard-container">
                  <cp-copy-to-clipboard-trigger :text="encodeUrl('instagram')">
                    <img src="/assets/img/instagram-icon.svg" />
                    <p class="footnote neutral4-color" v-margin="0">Instagram</p>
                  </cp-copy-to-clipboard-trigger>
                </a>
                <a class="clipboard-container">
                  <cp-copy-to-clipboard-trigger :text="encodeUrl('nextdoor')">
                    <i class="fa fa-home fa-2x home-color"></i>
                    <p class="footnote neutral4-color" v-margin="0">Nextdoor</p>
                  </cp-copy-to-clipboard-trigger>
                </a>
              </div>
            </section>
          </cp-box-content>
        </cp-box>
      </cp-dialog>
      <cp-share-post
        :showDialog="showDialogShare"
        :post="post"
        :type="type"
        :handleDialog="handleDialogShare"
        :results-url-suffix="resultsUrlSuffix"
      ></cp-share-post>
    </template>
    <template v-else-if="notModal">
      <cp-box>
        <cp-box-content centered>
          <section style="margin: auto; max-width: 55ch; text-align: center">
            <header class="heading-1">Share {{ shareCategory }}</header>
            <br />

            <div style="margin-bottom: 25px; align-items: center" v-if="shareCategory != 'CrowdpacTv' && allowShareFeed">
              <p class="heading-2">CrowdBlue Explore Feed</p>
              <cp-button bold primary @click="handleDialogs" class="btn-share-feed"> Share </cp-button>
            </div>

            <svg
              @click.prevent="handleShowDialog()"
              class="close-svg-icon"
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
              ></path>
            </svg>
            <div class="share-network-list">
              <a :href="blueskyRedirection()" target="_blank" class="share-network-sms"
                ><img src="/assets/img/bluesky-icon.svg" class="twitter-img" />
                <p class="footnote neutral4-color" v-margin="0">Bluesky</p>
              </a>
              <share-network
                v-for="network in networks"
                :network="network.network"
                :key="network.network"
                :url="network.network !== 'whatsapp' ? encodeUrl(network.network) : ''"
                :title="title"
                :description="`${description}\n${encodeUrl(network.network)}`"
                :quote="quote"
                :hashtags="hashtags"
                :twitterUser="twitterUser"
              >
                <img v-if="network.image" :src="network.image" class="twitter-img" />
                <i v-else :class="network.icon"></i>
                <p class="footnote neutral4-color" v-margin="0">{{ network.name }}</p>
              </share-network>
              <a :href="smsRedirection()" class="share-network-sms"
                ><i class="fal fa-comment-dots fa-2x black-color"></i>
                <p class="footnote neutral4-color" v-margin="0">SMS</p>
              </a>
              <a :href="emailRedirection()" class="share-network-email"
                ><i class="fal fa-envelope fa-2x black-color"></i>
                <p class="footnote neutral4-color" v-margin="0">Email</p>
              </a>
              <a class="clipboard-container">
                <cp-copy-to-clipboard-trigger :text="encodeUrl('instagram')">
                  <img src="/assets/img/instagram-icon.svg" />
                  <p class="footnote neutral4-color" v-margin="0">Instagram</p>
                </cp-copy-to-clipboard-trigger>
              </a>
              <a class="clipboard-container">
                <cp-copy-to-clipboard-trigger :text="encodeUrl('nextdoor')">
                  <i class="fa fa-home fa-2x home-color"></i>
                  <p class="footnote neutral4-color" v-margin="0">Nextdoor</p>
                </cp-copy-to-clipboard-trigger>
              </a>
            </div>
          </section>
        </cp-box-content>
      </cp-box>
      <cp-share-post
        :showDialog="showDialogShare"
        :post="post"
        :type="type"
        :handleDialog="handleDialogShare"
        :results-url-suffix="resultsUrlSuffix"
      ></cp-share-post>
    </template>
    <template v-else>
      <div class="share-network-list">
        <a :href="blueskyRedirection()" target="_blank" class="share-network-sms"
          ><img src="/assets/img/bluesky-icon.svg" class="twitter-img" />
          <p class="footnote neutral4-color" v-margin="0">Bluesky</p>
        </a>
        <share-network
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :url="network.network !== 'whatsapp' ? encodeUrl(network.network) : ''"
          :title="title"
          :description="`${description}\n${encodeUrl(network.network)}`"
          :quote="quote"
          :hashtags="hashtags"
          :twitterUser="twitterUser"
        >
          <img v-if="network.image" :src="network.image" class="twitter-img" />
          <i v-else :class="network.icon"></i>
          <p class="footnote neutral4-color" v-margin="0">{{ network.name }}</p>
        </share-network>
        <a :href="smsRedirection()" class="share-network-sms"
          ><i class="fal fa-comment-dots fa-2x black-color"></i>
          <p class="footnote neutral4-color" v-margin="0">SMS</p>
        </a>
        <a :href="emailRedirection()" class="share-network-email"
          ><i class="fal fa-envelope fa-2x black-color"></i>
          <p class="footnote neutral4-color" v-margin="0">Email</p>
        </a>
        <cp-copy-to-clipboard-trigger :text="encodeUrl('instagram')">
          <a>
            <div class="icon-wrapper">
              <img src="/assets/img/instagram-icon.svg" />
              <p class="footnote neutral4-color" v-margin="0">Instagram</p>
            </div>
          </a>
        </cp-copy-to-clipboard-trigger>
        <cp-copy-to-clipboard-trigger :text="encodeUrl('nextdoor')">
          <a>
            <div class="icon-wrapper">
              <i class="fa fa-home fa-2x home-color"></i>
              <p class="footnote neutral4-color" v-margin="0">Nextdoor</p>
            </div>
          </a>
        </cp-copy-to-clipboard-trigger>
      </div>
    </template>
  </div>
</template>
<style>
.btn-share-feed span.button__content {
  padding: 0.6em 1em !important;
  margin-right: 0 !important;
}
.heading-2 {
  text-align: center !important;
  font-family: var(--serif-font) !important;
  font-size: 20px !important;
  font-weight: 300 !important;
  line-height: 1.3 !important;
}
.share-network-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(85px, 1fr));
  justify-content: center;
  justify-items: center;
  max-width: 400px;
}
.clipboard-container,
a[class^='share-network-'] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 58px;
  height: 54px;
  border: 1px solid var(--neutral5);
  border-radius: 16px;
  padding: 8px;
  box-shadow: 0px 2px 5px 0px #0000001A;
  background-color: var(--white);
  cursor: pointer;
  margin: 5px;
}
a:hover {
  text-decoration: none;
  opacity: 0.85;
}

a[class^='share-network-'] .fah {
  padding: 10px 10px 5px 10px;
  flex: 0 1 auto;
  margin: 0 auto;
  font-size: 32px;
  line-height: 100%;
}

.icon-wrapper-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 58px;
  height: 54px;
  border: 1px solid var(--neutral5);
  border-radius: 16px;
  padding: 8px;
  box-shadow: 0px 2px 5px 0px #0000001A;
  background-color: var(--white);
  cursor: pointer;
  margin: 5px;
}

a[class^='share-network-'] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}
svg.share-svg-icon {
  height: 1em;
  width: 1em;
}
svg.close-svg-icon {
  float: right;
  top: 5px;
  right: 5px;
  position: absolute;
  height: 2.5em;
  width: 2.5em;
}
div.feed svg {
  color: #555555 !important;
  height: 1.5em !important;
  width: 1.5em !important;
}
div.post-action-button.share div.feed svg {
  height: 1.7em !important;
  width: 1.7em !important;
}
div.post-action-button.share div.feed .share-text {
  position: initial;
  vertical-align: super;
}

div.campaign {
  margin: 0px;
  line-height: inherit;
  margin-right: 15px;
}
.close-icon {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
}

.twitter-img {
  width: 2em;
}
</style>
